export default "__VITE_ASSET__29b15560__"